import { DATASET_PROP } from "../consts";
import { PanelDatasetMixin } from "./PanelDatasetMixin";

/**
 * Create Panel Base Mixin
 *
 * @description Create "queryModels" by "props.datasets" under the hood
 *
 * @param {string|undefined|null} [prop=DATASET_PROP]
 * @return {VueMixin}
 */
export const usePanelDatasetMixin = ({ prop = DATASET_PROP } = {}) => ({
    mixins: [PanelDatasetMixin].concat(
        [undefined, null, '', DATASET_PROP].includes(prop) ? [] : { static: { DATASET_PROP: prop } }
    )
});